import { useEffect, useState } from "react";
import Header from "../components/header";
import { SignupModelHelper } from "../data/SignupModel";
import { AudioTestCapture, AudioTestCaptures } from "../services/audioTestMode";
import { UserService } from "../services/UserService";

// Resultado do modo teste: cada chamada que o fluxo real teria feito ao
// backend, na ordem, com o payload exato, e o SignupModel consolidado.

function pretty(value: unknown) {
  return JSON.stringify(value, null, 2);
}

function buildExport(captures: AudioTestCapture[]) {
  return {
    generatedAt: new Date().toISOString(),
    environment: 'cadastro-audio (modo teste, nada foi enviado)',
    signup: SignupModelHelper.get(),
    calls: captures
  };
}

export default function CadastroAudioResultado() {
  const [captures, setCaptures] = useState<AudioTestCapture[]>(() => AudioTestCaptures.list());
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    const refresh = () => setCaptures(AudioTestCaptures.list());
    window.addEventListener('audio-test-captures-changed', refresh);
    return () => window.removeEventListener('audio-test-captures-changed', refresh);
  }, []);

  const signup = SignupModelHelper.get();
  const exportText = pretty(buildExport(captures));

  async function copy(label: string, text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(label);
      setTimeout(() => setCopied(null), 1500);
    } catch {
      window.prompt('Copie o JSON:', text);
    }
  }

  function download() {
    const blob = new Blob([exportText], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `cadastro-audio-${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
    link.click();
    URL.revokeObjectURL(url);
  }

  function restart() {
    if (!window.confirm('Limpar as chamadas capturadas e o cadastro em andamento?')) return;
    AudioTestCaptures.clear();
    SignupModelHelper.reset();
    localStorage.removeItem('userId');
    localStorage.removeItem(UserService.key);
    document.location = '#/';
  }

  return (
    <>
      <Header step={ 1 } total={ 1 } title="Resultado do teste" previous="#"></Header>

      <div className="chat-container">
        <div className="chat audio-poc">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <p><strong>Nada foi enviado ao backend.</strong></p>
                    <p>Abaixo estão as { captures.length } chamadas que o cadastro real teria feito, na ordem, com o payload exato, e o modelo consolidado. Ids de deficiência e faixa salarial são fictícios neste ambiente.</p>
                  </div>
                </div>

                <div className="audio-poc-panel audio-poc-actions">
                  <button className="btn btn-outline audio-poc-small-button" onClick={ () => copy('tudo', exportText) }>
                    { copied === 'tudo' ? 'Copiado!' : 'Copiar tudo (JSON)' }
                  </button>
                  <button className="btn btn-outline audio-poc-small-button" onClick={ download }>Baixar .json</button>
                  <button className="btn btn-outline audio-poc-small-button" onClick={ restart }>Limpar e recomeçar</button>
                </div>

                <div className="audio-poc-section-title">
                  <strong>Chamadas capturadas</strong>
                  <span>{ captures.length }</span>
                </div>

                { captures.length === 0 &&
                  <div className="audio-poc-panel audio-poc-empty">
                    Nenhuma chamada ainda. Percorra o cadastro a partir de <a href="#/">#/</a>.
                  </div>
                }

                { captures.map((call) => (
                  <div className="audio-poc-panel audio-test-call" key={ call.seq }>
                    <div className="audio-poc-meta">
                      <span>#{ call.seq }</span>
                      <span>{ call.httpMethod } { call.url }</span>
                      <span>{ call.service }.{ call.method }</span>
                      <span>{ new Date(call.at).toLocaleTimeString('pt-BR') }</span>
                    </div>
                    <pre className="audio-poc-transcript audio-test-json">{ pretty(call.payload) }</pre>
                    <button className="btn btn-outline audio-poc-small-button" onClick={ () => copy(String(call.seq), pretty(call.payload)) }>
                      { copied === String(call.seq) ? 'Copiado!' : 'Copiar payload' }
                    </button>
                  </div>
                )) }

                <div className="audio-poc-section-title">
                  <strong>SignupModel consolidado</strong>
                  <span>localStorage</span>
                </div>
                <div className="audio-poc-panel audio-test-call">
                  <pre className="audio-poc-transcript audio-test-json">{ signup ? pretty(signup) : 'Nenhum cadastro em andamento.' }</pre>
                  { signup &&
                    <button className="btn btn-outline audio-poc-small-button" onClick={ () => copy('signup', pretty(signup)) }>
                      { copied === 'signup' ? 'Copiado!' : 'Copiar modelo' }
                    </button>
                  }
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
